import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { LanguageModel } from '@contler/core/dynamicTranslate';

@Component({
  selector: 'ctr-navigation',
  imports: [MatToolbarModule, MatIconModule, MatButtonModule, MatMenuModule, MatButtonModule],
  templateUrl: './navigation.component.html',
  styleUrl: './navigation.component.scss',
})
export class NavigationComponent implements OnChanges {
  @Input() languages: LanguageModel[] = [];
  @Input() actualLanguage: LanguageModel | null = null;
  @Input() logo: string | null = null;
  @Output() changeLanguage = new EventEmitter<LanguageModel>();
  @Output() menuClick = new EventEmitter<void>();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['languages'] && !this.actualLanguage) {
      this.actualLanguage = this.languages[0];
    }
  }

  clickMenu() {
    this.menuClick.emit();
  }

  changeLang(language: LanguageModel) {
    this.changeLanguage.emit(language);
  }
}
